import { getAdminUserInfo } from "../user/asyncThunks";
import { login, logout, refresh } from "./asyncThunks";

export const loginBuilder = (builder) => {
  builder.addCase(login.pending, (state) => {
    state.loginPending = true;
  });
  builder.addCase(login.fulfilled, (state, action) => {
    const { accessToken } = action.payload;
    // Access token zivi samo u memoriji (redux); refresh token je httpOnly cookie.
    // Tokeni se NE cuvaju u localStorage (XSS rizik).
    state.loginPending = false;
    state.loggedIn = true;
    state.token = accessToken;
  });
  builder.addCase(login.rejected, (state) => {
    state.loginPending = false;
  });
};

export const getAdminUserInfoBuilder = (builder) => {
  builder.addCase(getAdminUserInfo.pending, (state) => {
    state.getAdminUserInfoPending = true;
  });
  builder.addCase(getAdminUserInfo.fulfilled, (state) => {
    state.getAdminUserInfoPending = false;
    state.loggedIn = true;
  });
  builder.addCase(getAdminUserInfo.rejected, (state) => {
    state.getAdminUserInfoPending = false;
  });
};

export const logoutBuilder = (builder) => {
  builder.addCase(logout.pending, (state) => {
    state.loggedIn = false;
    state.token = null;
  });
  builder.addCase(logout.fulfilled, (state) => {
    state.token = null;
  });
  builder.addCase(logout.rejected, (state) => {
    state.token = null;
  });
};

export const refreshBuilder = (builder) => {
  builder.addCase(refresh.fulfilled, (state, action) => {
    const { accessToken } = action.payload;
    state.token = accessToken;
  });
};
